import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Button, Container, Image, Segment } from 'semantic-ui-react'

import Availability from '../availability'
import defaultAvatar from '../../assets/images/default-avatar.png'
import edit from '../../assets/images/edit.png'
import { defaultLanguage, tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { upload } from '../../helpers/uploads'
import { defaultTimezone } from '../../helpers/timezones'
import Navbar from '../navbar'
import ProfileForm from './form'
import { actions as messages } from '../../store/actions/messages'
import { actions as profiles } from '../../store/actions/profiles'
import { actions as settings } from '../../store/actions/settings'

class Profile extends Component {
    constructor(props) {
        super(props)
        const profile = props.profile || {}
        this.state = {
            bio: profile.bio || '',
            education: profile.education || '',
            firstName: profile.firstName || '',
            lastName: profile.lastName || '',
            phone: profile.phone || '',
            picture: profile.picture || '',
            preview: profile.picture || '',
            timezone: profile.timezone || defaultTimezone,
            language: profile.language || defaultLanguage,
            sessionLink: profile.sessionLink || '',
            view: 'profile',
            errors: {},
            doNotDisturb: false
        }
        autoBind(this)
        this.ref = React.createRef()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.profile !== this.props.profile) {
            const profile = this.props.profile
            this.setState({
                bio: profile.bio || '',
                education: profile.education || '',
                firstName: profile.firstName || '',
                lastName: profile.lastName || '',
                phone: profile.phone || '',
                picture: profile.picture || '',
                preview: profile.picture || '',
                timezone: profile.timezone || defaultTimezone,
                language: profile.language || defaultLanguage,
                sessionLink: profile.sessionLink || ''
            })
        }
    }

    changeValue(field, value) {
        this.setState({ [field]: value })
    }

    validatePhone(phone) {
        let reg = /^[0-9\-+() ]*$/
        return reg.test(phone)
    }

    validateInput(input) {
        let reg = /^[a-zA-Z ]*$/
        return reg.test(input)
    }

    validateTextarea(input) {
        let reg = /^[a-zA-Z0-9$\-_.+!*'(),\n\r]*$/
        let words = input.split(' ')
        for (let i = 0; i < words.length; i++) {
            if (!reg.test(words[i])) return false
        }
        return true
    }

    saveTherapist() {
        if (this.state.doNotDisturb) return

        this.setState({ doNotDisturb: true, errors: {} })
        let errors = {}

        if (!this.validateInput(this.state.firstName)) {
            errors = { ...errors, name: tr('NAME_INVALID') }
        }
        if (!this.validateInput(this.state.lastName)) {
            errors = { ...errors, surname: tr('SURNAME_INVALID') }
        }
        if (!this.validateTextarea(this.state.bio)) {
            errors = { ...errors, bio: tr('BIO_INVALID') }
        }
        if (!this.validateTextarea(this.state.education)) {
            errors = { ...errors, education: tr('EDUCATION_INVALID') }
        }

        if (!_.isEmpty(errors)) {
            this.setState({ doNotDisturb: false, errors })
            return
        }

        const profile = {
            bio: this.state.bio,
            education: this.state.education,
            name: this.state.firstName,
            surname: this.state.lastName,
            phone: this.state.phone,
            img_url: this.state.picture,
            timezone: this.state.timezone
        }

        // Update backend
        send({
            method: 'PUT',
            tokens: this.props.userTokens,
            url: '/therapist',
            data: profile
        })
            .then(() => {
                this.props.message({ type: 'info', text: tr('YOUR_CHANGES_HAVE_BEEN_SAVED') })
                // Update Redux store
                this.props.setProfile({
                    bio: profile.bio,
                    education: profile.education,
                    firstName: profile.name,
                    lastName: profile.surname,
                    phone: profile.phone,
                    picture: profile.img_url,
                    timezone: profile.timezone
                })
                this.setState({ doNotDisturb: false })
            })
            .catch((error) => {
                console.error('Failed to update therapist.', error)
                this.setState({ doNotDisturb: false })
                this.props.message({ type: 'error', text: tr('FAILED_TO_SAVE_CHANGES') })
            })
    }

    changeView(view) {
        if (view === this.state.view) return
        this.setState({ view })
    }

    fetchPresignedUrl(name) {
        return send({
            method: 'POST',
            tokens: this.props.userTokens,
            url: `/therapist/generateuploadurl?filename=${name}`
        })
            .then((response) => {
                return {
                    url: response.data.url,
                    previewUrl: response.data.preview_url,
                    contentType: response.data.content_type
                }
            })
    }

    uploadPicture(picture) {
        if (!picture) return

        this.fetchPresignedUrl(picture.name)
            .then(({ url, contentType, previewUrl }) => {
                return upload({ url, type: contentType, file: picture }).then(() => ({ url, previewUrl }))
            })
            .then(({ url, previewUrl }) => {
                // Update Redux store immediately
                this.setState({ picture: url, preview: previewUrl })
                this.props.setProfile({ picture: url })
            })
            .catch((error) => {
                console.error('Failed to upload picture.', error)
                this.props.message({ type: 'error', text: tr('FAILED_TO_UPLOAD_PICTURE') })
            })
    }

    goTo(location) {
        this.props.history.push(location)
    }

    render() {
        return (
            <Container className='profile'>
                <Navbar/>
                <Container className='settings'>
                    <Segment className='center aligned picture'>
                        <Image src={this.state.preview || defaultAvatar} circular centered/>
                        <Image
                            src={edit}
                            className='edit'
                            onClick={() => this.ref.current.click()}
                        />
                        <input
                            type='file'
                            ref={this.ref}
                            onChange={(e) => this.uploadPicture(e.target.files[0])}
                        />
                    </Segment>
                    <Segment className='center aligned set-availability'>
                        <Button onClick={() => this.changeView('availability')}>
                            {tr('SET_AVAILABILITY')}
                        </Button>
                    </Segment>
                    <ProfileForm
                        {...this.state}
                        email={this.props.email}
                        onChangeValue={this.changeValue}
                        onSave={this.saveTherapist}
                        onChangePassword={() => this.goTo('/password')}
                    />
                    {this.state.view === 'availability' && (
                        <Availability onClose={() => this.changeView('profile')}/>
                    )}
                </Container>
            </Container>
        )
    }
}

const mapStateToProps = (state) => ({
    email: state.profiles.profile.email,
    profile: state.profiles.profile,
    language: state.settings.language,
    timezone: state.settings.timezone,
    userTokens: state.users.userTokens
})

const mapDispatchToProps = (dispatch) => {
    return {
        message: bindActionCreators(messages, dispatch).message,
        setProfile: bindActionCreators(profiles, dispatch).setProfile,
        setLanguage: bindActionCreators(settings, dispatch).setLanguage,
        setTimezone: bindActionCreators(settings, dispatch).setTimezone
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile))



// WEBPACK FOOTER //
// ./src/components/profile/index.js